"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var React = __importStar(require("react"));
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var classnames_1 = __importDefault(require("classnames"));
var Layout_1 = require("../Layout");
var Header_1 = require("../Header/Header");
var LayoutContext_1 = require("../LayoutContext");
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        width: Layout_1.sidebarWith,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 0,
    },
}); });
var Sidebar = function (_a) {
    var children = _a.children, className = _a.className;
    var classes = useStyles();
    var _b = (0, LayoutContext_1.useLayoutContext)(), isMobileWidth = _b.isMobileWidth, isMobileSidebarOpened = _b.isMobileSidebarOpened, openMobileSidebar = _b.openMobileSidebar, closeMobileSidebar = _b.closeMobileSidebar;
    var opened = !isMobileWidth || isMobileSidebarOpened;
    return (React.createElement(material_1.SwipeableDrawer, { open: opened, onOpen: openMobileSidebar, onClose: closeMobileSidebar, variant: isMobileWidth ? 'temporary' : 'permanent' },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: (0, classnames_1.default)(classes.root, className) },
                React.createElement(Header_1.Header, null),
                children))));
};
exports.Sidebar = Sidebar;
//# sourceMappingURL=Sidebar.js.map